export interface MenuCallbacks {
  onScanQr?: () => void;
}

export class Menu {
  private root: HTMLDivElement;
  private resolveStart: (() => void) | null = null;

  constructor(host: HTMLElement, cb: MenuCallbacks = {}) {
    this.root = document.createElement('div');
    this.root.className = 'layer menu';
    this.root.innerHTML = `
      <div class="menu-card">
        <div class="menu-title">风语者</div>
        <div class="menu-sub">AI 纸飞机邮局</div>
        <p class="menu-desc">向云海里的 5 只 AI 居民投递一封短信。<br/>滑动蓄力 → 松手投出 → 收到回信 → 生成明信片。</p>
        <button class="menu-btn">开始派送</button>
        <button class="menu-qr">📱 扫码上手机体验</button>
        <p class="menu-tip">建议在手机浏览器横屏或竖屏均可体验</p>
      </div>
    `;
    host.appendChild(this.root);
    const btn = this.root.querySelector('.menu-btn') as HTMLButtonElement;
    btn.addEventListener('click', () => {
      this.hide();
      this.resolveStart?.();
    });
    const qrBtn = this.root.querySelector('.menu-qr') as HTMLButtonElement;
    qrBtn.addEventListener('click', () => cb.onScanQr?.());
  }

  waitForStart(): Promise<void> {
    return new Promise(res => { this.resolveStart = res; });
  }

  hide(): void {
    this.root.classList.add('hidden');
  }

  show(): void {
    this.root.classList.remove('hidden');
  }
}
